module.exports = __webpack_public_path__ + "img/inactive-15.39af7680.svg";